import React, { FunctionComponent, useState } from 'react';

import ColorSpot from './bits/ColorSpot';
import ImageFader from './bits/ImageFader';
import styles from './index.module.scss';

type Props = {
  colors;
};

const ColorPicker: FunctionComponent<Props> = ({ colors }) => {
  const [index, setIndex] = useState(0);

  return (
    <div className={styles.root}>
      <div className={styles['image-container']}>
        <ImageFader images={colors} currentIndex={index} />
      </div>
      <div className={styles['colors-container']}>
        {colors?.map((val, key) => {
          return (
            <ColorSpot
              key={key}
              id={key}
              color={val.color.hex}
              title={val.color.title}
              currentIndex={index}
              onClick={(id) => setIndex(id)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ColorPicker;
